import React, { useEffect, useState } from 'react'
import axios from "axios"
import { AnimatePresence, motion } from "framer-motion"
import { TypeAnimation } from 'react-type-animation'
import eye from "../../images/disc.webp"
import { v4 as uuidv4 } from 'uuid';
import Spinner from 'react-bootstrap/Spinner';


function Login({ serverURL, user, setUser, globalUserId, globalToken }) {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [registerResults, setRegisterResults] = useState("");
  const [loginView, setLoginView] = useState(false);
  // const [companyCode, setCompanyCode] = useState("");

  const register = async (e) => {
    e.preventDefault();
    const query = {
      "name": name,
      "username": username,
      "email": email,
      "password": password,
    }

    const registerNewUser = await axios.post(serverURL + "/users/registerUser", query);

    if (registerNewUser.status == 200) {
      console.log(registerNewUser.data)
      resetForm()

      setRegisterResults(
        <span className='alert alert-success w-100 text-center p-0'>
          Registered Success
        </span>
      )
    } else {
      console.log(registerNewUser.data)
      setRegisterResults(
        <span className='alert alert-danger w-100 text-center p-0'>
          {registerNewUser.data}
        </span>
      )
    }
  }

  const login = async (e) => {
    e.preventDefault();

    const query = {
      "userId": email,
      "password": password,
    }

    const registerNewUser = await axios.post(serverURL + "/users/login", query);

    if (registerNewUser.status == 200) {
      console.log(registerNewUser.data)
      setUser(registerNewUser.data)

      const storeCookies = await axios.get(serverURL + "/storeUser/" + query.userId + "/" + uuidv4(), { withCredentials: true });

      if (storeCookies.status == 200) {
        window.location.href = "/dashboard"
      } else {
        console.log(storeCookies.data)
      }
      setRegisterResults(
        <span className='alert alert-success w-100 text-center p-0'>
          Logged In
        </span>
      )
    } else {
      console.log(registerNewUser.data)
      setRegisterResults(
        <span className='alert alert-danger w-100 text-center p-0'>
          {registerNewUser.data}
        </span>
      )
    }
  }

  const resetForm = () => {
    setName("")
    setUsername("")
    setEmail("")
    setPassword("")
  }

  const checkCookies = async () => {
    const getCookies = await axios.get(serverURL + "/getCookieUser", { withCredentials: true });
    if (getCookies.status == 200) {
      let globalUserId = getCookies.data.user;
      let globalToken = getCookies.data.token;

      const checkValidCookies = await axios.post(serverURL + "/users/checkValidCookies", { "userId": globalUserId, "token": globalToken })
      if (checkValidCookies.status == 200) {
        console.log(checkValidCookies.data)
        window.location.href = "/dashboard"
      } else {
        console.log(checkValidCookies.data)
        setLoginView(true)
      }
    } else {
      setLoginView(true)
    }
  }


  useEffect(() => {
    checkCookies()
  }, [])

  return (
    <div className="vh-100 vw-100 d-flex justify-content-center align-items-center">
      {
        loginView ?
          <div className="container-fluid h-100">
            <div className="row h-100">
              <div className="col-12 col-lg-7 p-0 d-none d-lg-flex flex-column justify-content-center align-items-center">
                <img src={eye} alt="" style={{ height: "500px" }} />
                <h1 style={{ color: "white", margin: "10px" }}>Best Zirconia Disc in India</h1>
              </div>
              <div className="col-12 col-lg-5 d-flex justify-content-center align-items-center">
                <motion.div
                  initial={{ scale: .9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0, duration: 0.8 }}
                  className="formBox shadow p-5 w-100 overflow-hidden"
                  style={{ maxWidth: "500px" }}
                >
                  <form
                    className='w-100 d-flex flex-column justify-content-start align-items-center gap-5'
                    action=""
                    onSubmit={(e) => { login(e); }}>
                    <label htmlFor="" className='text-center fw-bold d-flex flex-column justify-content-center align-items-center gap-2'>
                      <img src="https://www.dentaldirekt.de/themes/custom/webksdct/logo.svg" alt="" className='w-100 logo' />
                      {/* <span className='fs-2 DentalDirectLogoText'>Dental Direkt</span> */}
                      {/* <span>LOGIN</span> */}
                    </label>

                    <div className='w-100 d-flex flex-column gap-4'>
                      {/* <label htmlFor="companyLog">
                        <input id="companyLog" className='loginFields' placeholder='Company Code' type="text" required value={companyCode} onInput={(e) => { setCompanyCode(e.target.value) }} />
                      </label> */}
                      <label htmlFor="emailLog" >
                        {/* Email */}
                        <input id="emailLog" className='loginFields' placeholder='Email' type="text" required value={email} onInput={(e) => { setEmail(e.target.value) }} />
                      </label>
                      <label htmlFor="passLog" >
                        {/* Password */}
                        <input id="passLog" className='loginFields' placeholder='Password' type="password" required value={password} onInput={(e) => { setPassword(e.target.value) }} />
                      </label>
                      {
                        registerResults ?
                          registerResults
                          :
                          ""
                      }
                    </div>
                    <div className='w-100 d-flex justify-content-center gap-3'>
                      <button type="submit" className='highlightedButton rounded-pill w-100' style={{ maxWidth: "170px" }}>Login</button>
                      {/* <button type='button' className='btn btn-md rounded-pill w-100 btn-outline-light' style={{ maxWidth: "170px" }} onClick={(e) => { setLoginView("Register"); setRegisterResults("") }}>Register</button> */}
                    </div>
                  </form>
                </motion.div>
              </div>
            </div>
          </div>
          :
          <Spinner animation="border" variant="light" size="lg" />
      }
    </div>
  )
}

export default Login